import bmr_notecard_stripe from "./notecard-stripe.png";

export const images = {
  "flashcard.background": bmr_notecard_stripe,
};
